import React from "react";
import { useLanguage } from "@/i18n/LanguageContext";
import { useTheme } from "@/theme/ThemeContext";
import {
  Utensils,
  Activity,
  BookOpen,
  UserCircle2,
  MoreHorizontal,
  Stethoscope,
  LayoutDashboard,
} from "lucide-react";

export default function MobileBottomNav({ activeSection, onSectionChange, isClinician = false }) {
  const { language } = useLanguage();
  const { isDark } = useTheme();
  const bg = language === "bg";

  // iter972 — new mobile nav per user + designer proposal:
  //   Моят Ден | Хранене | 📖 Рецепти | Профил | Още
  // • "Precision Health" and "Здраве" moved into the "Още" drawer.
  // • Cookbook (Рецепти) promoted to primary nav (61 recipes + AI menu +
  //   3 leaderboards). Personal daily-value module for female patients.
  // • "Профил" moved from More → primary nav (avatar / account).
  const tabs = [
    { id: "myday",   icon: LayoutDashboard, label: bg ? "Моят ден" : "My Day" },
    { id: "meals",   icon: Utensils,        label: bg ? "Хранене" : "Meals" },
    { id: "recipes", icon: BookOpen,        label: bg ? "Рецепти" : "Recipes" },
    ...(isClinician
      ? [{ id: "md", icon: Stethoscope, label: "MD", clinicianOnly: true }]
      : []),
    { id: "profile", icon: UserCircle2,     label: bg ? "Профил" : "Profile" },
    { id: "more",    icon: MoreHorizontal,  label: bg ? "Още" : "More" },
  ];

  return (
    <nav
      className={`mobile-bottom-nav md:hidden border-t ${
        isDark
          ? "bg-[hsl(222,47%,8%)] border-[hsl(223,47%,18%)]"
          : "bg-white border-[#E2E8F0]"
      }`}
      data-testid="mobile-bottom-nav"
    >
      <div className="flex items-center justify-around px-1 py-1">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeSection === tab.id;
          // MD tab gets distinct medical accent color (emerald) to signal clinician-only context
          const activeColor = tab.clinicianOnly ? "text-emerald-500" : "text-[#0EA5E9]";
          const dotColor = tab.clinicianOnly ? "bg-emerald-500" : "bg-[#0EA5E9]";
          return (
            <button
              key={tab.id}
              onClick={() => onSectionChange(tab.id)}
              data-testid={`mobile-tab-${tab.id}`}
              className={`flex flex-col items-center justify-center py-2 px-3 rounded-xl transition-all touch-target ${
                isActive
                  ? activeColor
                  : isDark
                  ? "text-gray-500"
                  : "text-[#94A3B8]"
              }`}
            >
              <Icon
                className={`w-5 h-5 ${isActive ? "scale-110" : ""}`}
                strokeWidth={isActive ? 2.5 : 2}
              />
              <span
                className={`text-[10px] mt-0.5 font-medium ${
                  isActive ? "opacity-100" : "opacity-70"
                }`}
              >
                {tab.label}
              </span>
              {isActive && (
                <div className={`w-1 h-1 rounded-full ${dotColor} mt-0.5`} />
              )}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
